module.exports = __webpack_public_path__ + "static/dashboard-e56ecea4628f4ad562ba524880bd2fd2.png";